import { useState, useEffect, useRef, createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { loaderContext } from "./LoaderProvider";
import socket from "../socket/socket";
import {
  BRANCHES_KEY,
  CURRENT_BRANCH_KEY,
  clearBranchCache,
  clearSession,
  readJSON,
} from "../services/session";
export const authContext = createContext();

const AuthProvider = (props) => {
  const [isAuth, setIsAuth] = useState(null);
  const [merchantData, setMerchantData] = useState({});
  const { setIsLoading } = useContext(loaderContext);
  const navigate = useNavigate();
  const token = localStorage.getItem("wow-delivery-kw-merchant-token");

  const auth = () => {
    if (
      token !== "" &&
      token !== null &&
      token !== undefined &&
      token.length > 0
    ) {
      axios
        .get(process.env.REACT_APP_API_ENDPOINT + "merchant/auth", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res && res.data.code === 1) {
            setMerchantData(res?.data?.data);
            if (localStorage.getItem("data-bs-theme") === null) {
              localStorage.setItem("data-bs-theme", "light");
            }

            const branchList = res?.data?.data?.branchList ?? [];

            if (branchList.length > 0) {
              localStorage.setItem(BRANCHES_KEY, JSON.stringify(branchList));

              const stored = readJSON(CURRENT_BRANCH_KEY);
              const stillValid = branchList.some(
                (item) => item?._id === stored?._id
              );

              if (!stillValid) {
                const fallback =
                  branchList.find(
                    (item) => item?._id === res?.data?.data?.branchId
                  ) ?? branchList[0];
                localStorage.setItem(
                  CURRENT_BRANCH_KEY,
                  JSON.stringify(fallback)
                );
              }
            } else {
              clearBranchCache();
            }
            setIsAuth(true);
            setIsLoading(false);
          } else {
            clearSession();
            setIsAuth(false);
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401 || err?.response?.status === 403) {
            clearSession();
          }
          setIsAuth(false);
          console.log(err);
        });
    } else {
      clearBranchCache();
      setIsAuth(false);
    }
  };

  useEffect(() => {
    auth();
    // eslint-disable-next-line
  }, [token, navigate, setIsLoading]);
  const authRef = useRef(auth);
  authRef.current = auth;

  const refresh = () => {
    if (!localStorage.getItem("wow-delivery-kw-merchant-token")) return;
    authRef.current();
  };

  useEffect(() => {
    socket.on(`admin:merchantDataUpdate`, (data) => {
      if (data) {
        refresh();
      }
    });
    socket.on(`merchant:balanceUpdate`, () => {
      refresh();
    });
    return () => {
      socket.off(`admin:merchantDataUpdate`);
      socket.off(`merchant:balanceUpdate`);
    };
    // eslint-disable-next-line
  }, []);
  return (
    <authContext.Provider value={[isAuth, setIsAuth, merchantData]}>
      {props.children}
    </authContext.Provider>
  );
};

export default AuthProvider;
